import { createApi } from '@reduxjs/toolkit/dist/query/react'
import { getBaseQueryAuth } from 'helpers/rtkQueryHelpers'

import { Coordinates, TService } from '../types'

// @ts-ignore
export const servicesApi = createApi({
  reducerPath: 'service',
  baseQuery: getBaseQueryAuth,
  refetchOnMountOrArgChange: true,
  tagTypes: ['services', 'service'],
  endpoints: builder => ({
    //получение всех сц
    getServices: builder.query<TService[], void>({
      query: () => ({
        url: `/v1/dealer/service/centers`,
        method: 'GET',
      }),
      transformResponse: (response: TService[]) => {
        const modifiedResponse = response.filter(item => item.active === true)
        return modifiedResponse
      },
      providesTags: ['services'],
    }),
    // поиск ближайшего сц
    getNearestService: builder.query<TService, Coordinates>({
      query: ({ latitude, longitude }) => ({
        url: `/v1/dealer/service/nearest-center?latitude=${latitude}&longitude=${longitude}`,
        method: 'GET',
      }),
      providesTags: ['service'],
    }),
    // получение сц по id
    getServiceById: builder.query<TService | null, string>({
      queryFn: async (id, { dispatch }) => {
        const servicesData: TService[] = await dispatch(
          servicesApi.endpoints.getServices.initiate(),
        ).unwrap()

        const service = servicesData.find(item => item.uuid === id)

        return { data: service ? service : null }
      },
      providesTags: ['services'],
    }),
    // получение данных о сц 2 способами
    // в зависимости от переданных данных
    getServiceCenterInformation: builder.query<
      TService | null,
      { coordinates?: Coordinates; id?: string }
    >({
      queryFn: async ({ coordinates, id }, { dispatch }) => {
        let service = null
        // если передаются координаты, вызывается поиск ближайшего по адресу
        // если передается id, то идет поиск сервисного центра из списка центров
        if (coordinates?.latitude) {
          service = (await dispatch(
            servicesApi.endpoints.getNearestService.initiate(coordinates),
          ).unwrap()) as TService
          return { data: service }
        }
        if (id) {
          service = (await dispatch(
            servicesApi.endpoints.getServiceById.initiate(id),
          ).unwrap()) as TService
          return { data: service }
        }

        return { data: service }
      },
      providesTags: ['service', 'services'],
    }),
  }),
})

export const {
  useGetServicesQuery,
  useGetNearestServiceQuery,
  useGetServiceCenterInformationQuery,
} = servicesApi
